
<div class="tab-header">{{Header }}</div>
<div class="close-btn">
    <mat-icon class="mat-icon" aria-hidden="false"  aria-label="" fontIcon="close" (click)="closeTab($event)"></mat-icon>
</div>
